import { Dialog } from "@mui/material";
import { withStyles } from "@mui/styles";

export const StyledDialog = withStyles((theme) => ({
  root: (props) => ({
    position: "fixed !important",
    right: "0 !important",
    bottom: "0 !important",
    top: "0 !important",
    left: "0 !important",
    zIndex: `${props.zindex ?? 20000} !important`,
  }),
}))(Dialog);
